import { createBrowserRouter } from "react-router-dom";
import App from "./App";
import Home from "./pages/Home/Home.jsx";
import HtmlInterview from "./pages/web-technology/HTML";
import CssInterview from "./pages/web-technology/CSS";
import JavaScriptInterview from "./pages/web-technology/Javascript";
import ReactInterview from "./pages/web-technology/ReactJS";
import Jquery from "./pages/web-technology/Jquery";
import BootStrap from "./pages/web-technology/BootStrap";
import Sass from "./pages/web-technology/Sass";
import Less from "./pages/web-technology/Less";
import NodeJS from "./pages/web-technology/NodeJS";
import ExpressJS from "./pages/web-technology/ExpressJS";
import Angular from "./pages/web-technology/Angular";
import Vue from "./pages/web-technology/Vue";
import Json from "./pages/web-technology/Json";
import Http from "./pages/web-technology/Http";
import DHTML from "./pages/web-technology/DHTML";
import SSRS from "./pages/dot-net/SSRS";
import SSIS from "./pages/dot-net/SSIS";
import WebApi from "./pages/dot-net/WebApi";
import ASPDOTNET from "./pages/dot-net/ASPDOTNET";
import ADODOTNET from "./pages/dot-net/ADODOTNET";
import WPF from "./pages/dot-net/WPF";
import LINQ from "./pages/dot-net/LINQ";
import SharePoint from "./pages/dot-net/SharePoint";
import FSharp from "./pages/dot-net/FSharp";
import VbNet from "./pages/dot-net/VbNet";
import SQL from "./pages/database/SQL";
import MYSQL from "./pages/database/MYSQL";
import Oracle from "./pages/database/Oracle";
import MonogDb from "./pages/database/MonogDb";
import Redis from "./pages/database/Redis";
import Python from "./pages/python/Python";
import PHP from "./pages/php/PHP";
import Java from "./pages/java/Java";
import CPP from "./pages/tech/CPP";
import C from "./pages/tech/C";
import CSharp from "./pages/dot-net/CSharp";
import DotNet from "./pages/dot-net/DotNet";
import R from "./pages/tech/R";
import GO from "./pages/tech/GO";
import GIT from "./pages/tech/GIT";
import Bash from "./pages/tech/Bash";
import XML from "./pages/tech/XML";
import AI from "./pages/tech/AI";
import Github from "./pages/tech/Github";
import Docker from "./pages/tech/Docker";
import Linux from "./pages/tech/Linux";
import Math from "./pages/tech/Math";
import PhotoShop from "./pages/tech/PhotoShop";
import Kotlin from "./pages/mobile-app/Kotlin";
import Swift from "./pages/mobile-app/Swift";
import Dart from "./pages/mobile-app/Dart";
import Rust from "./pages/tech/Rust";
import TypeScript from "./pages/web-technology/TypeScript";
import ReactNative from "./pages/web-technology/ReactNative";
import AWS from "./pages/cloud/AWS";
import Quiz from "./components/Quiz/Quiz";
import NotFound from "./pages/NotFound";

const router = createBrowserRouter([
    {
      path: "/",
      "element": <App />,
      "children": [
        {
            "index": true,
            "element": <Home />
        },
                {
            "path": "/html",
            "element": <HtmlInterview />
        },
        {
            "path": "/css",
            "element": <CssInterview />
        },
        {
            "path": "/quiz/:type",
            "element": <Quiz />
        },
        {
            "path": "/javascript",
            "element": <JavaScriptInterview />
        },
        {
            "path": "/react",
            "element": <ReactInterview />
        },
        {
            "path": "/jquery",
            "element": <Jquery />
        },
        {
            "path": "/bootstrap",
            "element": <BootStrap />
        },
        {
            "path": "/less",
            "element": <Less />
        },
        {
            "path": "/sass",
            "element": <Sass />
        },
        {
            "path": "/nodejs",
            "element": <NodeJS />
        },
        {
            "path": "/expressjs",
            "element": <ExpressJS />
        },
        {
            "path": "/angular",
            "element": <Angular />
        },
        {
            "path": "/vue",
            "element": <Vue />
        },
        {
            "path": "/json",
            "element": <Json />
        },
        {
            "path": "/http",
            "element": <Http />
        },
        {
            "path": "/dhtml",
            "element": <DHTML />
        },
        {
            "path": "/ssrs",
            "element": <SSRS />
        },
        {
            "path": "/ssis",
            "element": <SSIS />
        },
        {
            "path": "/wepapi",
            "element": <WebApi />
        },
                {
            "path": "/asp-dotne",
            "element": <ASPDOTNET />
        },
        {
            "path": "/ado-dotnet",
            "element": <ADODOTNET />
        },
        {
            "path": "/wpf",
            "element": <WPF />
        },
        {
            "path": "/linq",
            "element": <LINQ />
        },
        {
            "path": "/sharepoint",
            "element": <SharePoint />
        },
        {
            "path": "/fsharp",
            "element": <FSharp />
        },
        {
            "path": "/vbdotnet",
            "element": <VbNet />
        },
        {
            "path": "/sql",
            "element": <SQL />
        },
        {
            "path": "/mysql",
            "element": <MYSQL />
        },
        {
            "path": "/oracle",
            "element": <Oracle />
        },
        {
            "path": "/mongodb",
            "element": <MonogDb />
        },
        {
            "path": "/redis",
            "element": <Redis />
        },
                {
            "path": "/python",
            "element": <Python />
        },
        {
            "path": "/php",
            "element": <PHP />
        },
        {
            "path": "/java",
            "element": <Java />
        },
        {
            "path": "/cpp",
            "element": <CPP />
        },
        {
            "path": "/c",
            "element": <C />
        },
        {
            "path": "/csharp",
            "element": <CSharp />
        },
        {
            "path": "/dotnet",
            "element": <DotNet />
        },
        {
            "path": "/r",
            "element": <R />
        },
        {
            "path": "/go",
            "element": <GO />
        },
        {
            "path": "/git",
            "element": <GIT />
        },
        {
            "path": "/bash",
            "element": <Bash />
        },
        {
            "path": "/xml",
            "element": <XML />
        },
        {
            "path": "/ai",
            "element": <AI />
        },
                {
            "path": "/github",
            "element": <Github />
        },
        {
            "path": "/docker",
            "element": <Docker />
        },
        {
            "path": "/linux",
            "element": <Linux />
        },
        {
            "path": "/math",
            "element": <Math />
        },
        {
            "path": "/photoshop",
            "element": <PhotoShop />
        },
        {
            "path": "/kotlin",
            "element": <Kotlin />
        },
        {
            "path": "/swift",
            "element": <Swift />
        },
        {
            "path": "/dart",
            "element": <Dart />
        },
        {
            "path": "/rust",
            "element": <Rust />
        },
        {
            "path": "/typescript",
            "element": <TypeScript />
        },
        {
            "path": "/react-native",
            "element": <ReactNative />
        },
        {
            "path": "/aws",
            "element": <AWS />
        },
        {
            "path": "*",
            "element": <NotFound />
        },
      ]
    }
]);

export default router;